// src/utils/format.js
export function formatTimestamp(ts) {
    if (!ts) return "-";
    let date;
    // Firestore Timestamp object support
    if (typeof ts.toDate === "function") {
        date = ts.toDate();
    } else if (ts.seconds) {
        date = new Date(ts.seconds * 1000);
    } else if (typeof ts === "string" || typeof ts === "number") {
        date = new Date(ts);
    } else {
        return "-";
    }
    return date
        .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        })
        .replace(",", "");
}
